let wakeLock: any | undefined;
let refCount = 0;

const requestWakeLock = async () => {
    try {
        wakeLock = await (navigator as any).wakeLock.request("screen");

        // listen for our release event
        wakeLock.onrelease = function () {
            // don't do anything, we will reinitialise when we get visibility back
        };
    } catch (err) {
        // if wake lock request fails - usually system related, such as battery
    }
};

export function enableWakeLock() {
    ++refCount;
    if (!wakeLock) {
        requestWakeLock();
    }
}

export function disableWakeLock() {
    --refCount;
    if (refCount === 0 && wakeLock) {
        wakeLock.release();
        wakeLock = undefined;
    }
}

const handleVisibilityChange = () => {
    if (wakeLock !== null && document.visibilityState === "visible") {
        requestWakeLock();
    }
};

document.addEventListener("visibilitychange", handleVisibilityChange);
